import { alpha } from '@mui/material/styles';
import isHighContrastTheme from '%evp_theme/brandbook/appearance/isHighContrastTheme';
import { resolveControlBorderWidth } from './highContrastSx';

const FOCUS_RING_SX = {
    outline: theme => `${theme.shape.focusRingWidth}px solid`,
    outlineColor: 'primary.main',
    outlineOffset: 2,
};

export const FOCUS_OUTLINE_RESET_SX = {
    '&:focus': { outline: 'none' },
};

export function createFieldFocusHalo(theme, { color, haloOpacity }) {
    if (isHighContrastTheme(theme)) {
        return `0 0 0 ${theme.shape.focusRingWidth - resolveControlBorderWidth(theme)}px ${color}`;
    }

    return `0 0 0 3px ${alpha(color, haloOpacity)}`;
}

export default FOCUS_RING_SX;
